import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import RugianoProjectsTableFilters from "components/subComponents/RugianoProjectsTableFilters";

import useRugianoProjectsList from "hooks/list/useRugianoProjectsList";

function ElencoProgettiRugiano() {
    const rugianoProjectsListHook = useRugianoProjectsList();

    const { navigateToNewProject, dataTableHook, alertConfirmHook } = rugianoProjectsListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <RugianoProjectsTableFilters rugianoProjectsListHook={rugianoProjectsListHook} />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewProject}>
                        Nuovo progetto
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoProgettiRugiano;
